<ng-container *ngFor="let item of list; let last=last">
	<span *ngIf="tpl"><ng-template [ngTemplateOutlet]="tpl" [ngTemplateOutletContext]="{item: item}"></ng-template></span>
	<span class="item" *ngIf="!tpl" title="{{title(' ' + ('Separator' | cpLabelTranslate) + ' ')}}">{{ item }}</span>
	<span class="item" *ngIf="addSpaces && !last">&nbsp;</span>
	<span class="separator" *ngIf="!last">{{ "Separator" | cpLabelTranslate }}</span>
	<span class="item" *ngIf="addSpaces && !last">&nbsp;</span>
</ng-container>
